import { select } from '@redux-saga/core/effects'
import { call, PutEffect } from 'redux-saga/effects'
import type { RootState } from 'state/store'

import api from '../../../../../api/_legacy'

const TENANT_ID = 'absa'

export function submitAccountSaga(onSuccess: PutEffect, onFail: (e: any) => PutEffect) {
  return function* saveTradeSaga() {
    const state: RootState = yield select()
    const { builder } = state
    const { accountId } = builder

    if (!accountId) {
      throw new Error('FATAL ERROR: accountId has not been set')
    }

    try {
      yield call(api.tenant.submitCreate, accountId, TENANT_ID)

      yield onSuccess
    } catch (error) {
      yield onFail(error)
    }
  }
}
